
export default [{
	path: '/products-categories',
	component: () => import('@/components/products-categories/List')
}]
